import { useEffect } from "react";

/**
 * Ping component. Ping the WP Ajax action: ping_library to keep the session alive.
 */

const Ping = () => {

    useEffect(() => {

        const ping = async () => {
            /**
             * Make sure we are not loaded onto a contract page
             * This is found checking if the url contains /contract/
             */

            if (window.location.href.includes("/contract/") || window.location.href.includes("/free-webinar/")) {
                console.log("Contract ping");
                return;
            }
            try {

                const response = await fetch("/wp-admin/admin-ajax.php", {
                    mode: "cors",
                    method: "POST",
                    headers: {
                        "Access-Control-Allow-Origin": "*",
                        "X-WP-Nonce": window?.rpReactPlugin?.nonce, // Use correct nonce name
                        "Content-Type": "application/x-www-form-urlencoded",
                    },
                    body: new URLSearchParams({
                        action: "ping_library", // Replace with your actual action name
                    }),
                });

                // Ensure the response is okay before processing it
                if (!response.ok) {
                    throw new Error(`HTTP error! Status: ${response.status}`);
                }

                const text = await response.text(); // Read raw text

                try {
                    const data = JSON.parse(text); // Try to parse JSON

                    if (data.success === false) {
                        // Reload page
                        console.log("Ping failed, reloading page...");
                        window.location.reload();
                    }
                } catch (jsonError) {
                    console.error("JSON parsing error:", jsonError);
                }
            } catch (error) {
                console.error("Ping request failed:", error);
            }
        };

        const interval = setInterval(() => {
            ping();
        }, 20000);

        return () => clearInterval(interval);
    }, []);

    return null;
};

export default Ping;
